import React from 'react';
import { getThemeNameList, getLocalizedThemeName, getThemeIconPath, getLocalizedThemeMainColors } from '../../../../assets/creator/themes';
import "./StyleMenuThemes.css";

const pen = (<svg className="edit-colors-button__icon" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.539 5.047 10.335 17.68l-.671-1.171a1.532 1.532 0 0 0-1.31-.752l-1.394.01 7.252-12.62a.179.179 0 0 1 .11-.085.177.177 0 0 1 .136.017l3.014 1.72a.181.181 0 0 1 .067.247zM6.553 20.433l-.094-3.161 1.904-.016.935 1.632-2.745 1.545zm12.45-15.92a1.672 1.672 0 0 0-.787-1.015l-3.014-1.72a1.668 1.668 0 0 0-1.275-.162 1.671 1.671 0 0 0-1.017.786L5.029 16.119a.727.727 0 0 0-.087.4c0 .01-.006.02-.005.03l.152 5.168a.75.75 0 0 0 1.118.63l4.485-2.523c.012-.006.019-.017.03-.025a.729.729 0 0 0 .296-.287L18.842 5.79c.222-.39.28-.843.162-1.276z"/>
    </svg>
);

const ThemeOptionSelected = ({ themeName, onEditClick, onSelect  }) => (

    <div className="theme-option theme-option--selected" >
        <div className="theme-description" onClick={() => onSelect(themeName) } >
            <img className="theme-description__img" src={getThemeIconPath(themeName)} alt="" />
            <div>
                <p className="theme-description__name">{getLocalizedThemeName(themeName)}</p>
                <p className="theme-description__colors">{getLocalizedThemeMainColors(themeName)}</p>
            </div>
        </div>
        <div className="edit-colors-button" onClick={onEditClick} >
        <span className="edit-colors-button__edit">
                {/* {getTranslation("Edit")} */}
                </span>
            {pen}
      
        </div>
    </div>
);

const ThemeOptionNotSelected = ({ themeName, onSelect }) => (
    <div className="theme-option theme-option--not-selected" onClick={() => onSelect(themeName)} >
        <div className="theme-description"  >
            <img className="theme-description__img" src={getThemeIconPath(themeName)} alt="" />
            <div>
                <p className="theme-description__name">{getLocalizedThemeName(themeName)}</p>
                <p className="theme-description__colors">{getLocalizedThemeMainColors(themeName)}</p>
            </div>
        </div>
    </div>
);

const StyleMenuThemes = (props) => {
    const isThemeSelected = (themeName) => {
        return themeName === props.currentThemeName || (themeName === 'Default' && props.currentThemeName === undefined);
    };

    return (
        <React.Fragment>
            {
                getThemeNameList().map(themeName => {
                    if (isThemeSelected(themeName)) {
                        return (
                            <ThemeOptionSelected
                                key={themeName}
                                themeName={themeName}
                                onSelect={props.onThemeSelect}
                                currentThemeName={props.currentThemeName}
                                onSelectColor={props.onSelectColor}
                                onEditClick={props.onEditClick}
                                isCurrentTheme={true}
                            />
                        );
                    }
                    
                    return (
                        <ThemeOptionNotSelected
                            key={themeName}
                            themeName={themeName}
                            onSelect={props.onThemeSelect}
                            onSelectColor={props.onSelectColor}
                            onColorSelect={props.onSelectColor}
                            isCurrentTheme={true}
                        />
                    );
                })
            }
        </React.Fragment>
    );
};

export default StyleMenuThemes;